<template>
  <div class="register">
    <img alt="" class="back-ground" src="@/assets/images/img_bg@3x.png">
    <div class="register-logo">
      <img alt="" src="@/assets/images/LOGO@2x.png">
    </div>
    <van-form ref="loginForm" class="login-form" @submit="handleSubmitClick">
      <van-field
        v-for="(item,index) of loginFormList"
        :key="item.key"
        v-model="loginForm[item.key]"
        v-bind="item.bind"
        :name="item.key"
        :placeholder="$t(item.placeholder)"
        class="van-field"
      >
        <template v-if="index === 3|| index === 4" #right-icon>
          <img alt="" class="compile-icon" src="@/assets/images/icon_down@2x.png" @click="handleGetRegion(index)">
        </template>
        <template v-slot:label>
          <split-label :label="$t(item.label)" />
        </template>
      </van-field>
      <van-field
        v-model="loginForm['vertifyCode']"
        :placeholder="$t('verificationCode')"
      >
        <template v-slot:label>
          <split-label :label="$t('verificationCode')" />
        </template>
        <template #button>
          <div class="get-code">
            <van-button
              color="#3F92DD"
              native-type="button"
              plain
              @click="getCodeCount > 0 ? null : handleGetCodeClick()"
            >{{ $t('gain') }}{{ getCodeCount > 0 ? '(' + getCodeCount + ')' : $t('verificationCode') }}
            </van-button>
          </div>
        </template>
      </van-field>
      <dr-agreement v-model="loginForm.test" margin-top="48px" />
      <div class="button-enroll">
        <van-button block class="button-enroll-button" color="rgba(0,91,172,1)" native-type="submit" round type="info" @click="handleSubmitClick">
          {{ $t('signUp') }}
        </van-button>
      </div>
    </van-form>
    <van-popup v-model="show" class="equipment-popup" position="bottom" round>
      <van-picker
        :columns="columns"
        show-toolbar
        title="省份"
        @cancel="show = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <van-popup v-model="showCity" class="equipment-popup" position="bottom" round>
      <van-picker
        :columns="columnsCity"
        show-toolbar
        title="城市"
        @cancel="showCity = false"
        @confirm="onConfirmCity"
      />
    </van-popup>
  </div>
</template>

<script>
import DrAgreement from '@/components/Agreement'
import { PHONE_REG } from '@/utils/validate'
import CodeMixin from '@/mixin/code'
import { loginFormList } from '@/utils/titleList'
import { getLocalStore } from '@/utils'
import { Toast } from 'vant'

export default {
  name: 'Register',
  comments: {
    getdeviceCode() {
      this.getdeviceCode = getLocalStore('deviceCode')
    }
  },
  components: { DrAgreement },
  mixins: [CodeMixin],
  data() {
    return {
      isCity: true, // 城市选择器
      areaListCity: [], // 城市列表
      showCity: false, // 城市弹出框
      columns: [], // 地区列表
      areaList: [], // 地区id表
      columnsCity: [], // 城市列表
      show: false, // 省市选择弹出框
      regionCode: 0, // 地区代码
      provinceCode: '', // 省份
      cityCode: '', // 城市
      loginFormList, // 列表信息
      // 注册信息
      loginForm: {
        test: true,
        openId: this.$route.query.openid,
        unionid: this.$route.query.id,
        model: '',
        cityId: '',
        provinceId: '',
        phonenum: '',
        vertifyCode: '',
        hospitalPosition: '',
        hospitalDepartment: '',
        deviceCode: typeof getLocalStore('deviceCode') === 'string' ? getLocalStore('deviceCode') : '',
        name: '',
        hospitalName: '',
        hospitalAddress: ''
      }
    }
  },
  watch: {
    // 监听设备码 自动填入
    'loginForm.deviceCode': {
      handler() {
        this.watchHandler()
      }
    }
  },
  mounted() {
    this.handleGetCity()
    this.handleMountedDcode()
  },
  methods: {
    // 监听设备输入框 填写信息
    watchHandler() {
      var self = this
      if (this.loginForm.deviceCode.length > 5) {
        this.$api('EQUIPMENT_INFO', {
          deviceCode: this.loginForm.deviceCode
        }).then((res) => {
          if (res.code !== 200) {
            self.loginForm.hospitalName = ''
            self.loginForm.model = ''
            self.loginForm.province = ''
            self.loginForm.city = ''
            return
          }
          self.loginForm.model = res.result.productModeDesc
          self.loginForm.hospitalName = res.result.endUserName
          self.loginForm.province = res.result.province
          self.loginForm.city = res.result.city
          self.loginForm.provinceId = res.result.provinceId
          self.onConfirm(self.loginForm.province, 'no')
          // this.onConfirmCity(this.loginForm.city)
          // var self = this
          self.res = res
          self.$api('PROVINCE_CITY_SEARCH_H5', {
            personId: res.result.provinceId
          }, true).then(res => {
            console.log(res.result)
            self.areaListCity = res.result.map(item => {
              const { id, name } = item
              return {
                id,
                name
              }
            })
            self.columnsCity = []
            self.areaListCity.forEach(item => {
              self.columnsCity.push(item.name)
            })
            self.loginForm.cityId = self.res.result.cityId
          })
        // this.onConfirmCity(this.loginForm.city)
        })
      }
    },
    // 扫码带入信息
    handleMountedDcode() {
      if (typeof getLocalStore('deviceCode') === 'string') {
        this.$api('EQUIPMENT_INFO', {
          deviceCode: getLocalStore('deviceCode')
        }).then((res) => {
          if (res.result === null) {
            this.userSumbitList.hospitalName = ''
            this.userSumbitList.model = ''
            return
          }
          this.loginForm.model = res.result.productModeDesc
          this.loginForm.hospitalName = res.result.endUserName
          this.loginForm.province = res.result.province
          this.loginForm.city = res.result.city
          this.loginForm.provinceId = res.result.provinceId
          this.onConfirm(this.loginForm.province, 'no')
          var self = this
          self.res = res
          this.$api('PROVINCE_CITY_SEARCH_H5', {
            personId: res.result.provinceId
          }, true).then(res => {
            console.log()
            self.areaListCity = res.result.map(item => {
              const { id, name } = item
              return {
                id,
                name
              }
            })
            self.columnsCity = []
            self.areaListCity.forEach(item => {
              self.columnsCity.push(item.name)
            })
            self.loginForm.cityId = self.res.result.cityId
          })
          // this.onConfirmCity(this.loginForm.city)
        })
      }
    },
    /*
      选择地区（弹出层）
    */
    handleGetRegion(index) {
      if (index === 3) {
        this.isCity = false
        this.show = true
        return
      }
      if (this.isCity) {
        this.areaList.forEach(item => {
          if (item.name === this.loginForm.province) {
            this.regionCode = item.id
          }
        })
        this.handleGetCity('city')
      }
      this.showCity = true
    },
    /*
      选择省
    */
    onConfirm(val, type) {
      this.loginForm.province = val + ''
      this.areaList.forEach(item => {
        if (item.name === this.loginForm.province) {
          this.regionCode = item.id
          this.loginForm.cityId = ''
        }
      })
      this.loginForm.provinceId = this.regionCode
      this.handleGetCity('city')
      this.show = false
      if (type !== 'no') {
        this.loginForm.city = ''
      }
    },
    /*
      选择市
    */
    onConfirmCity(val) {
      this.loginForm.city = val + ''
      this.regionCode = 0
      const that = this
      that.loginForm.cityId = ''
      this.handleGetCity('', function() {
        that.areaListCity.forEach(item => {
          if (item.name === that.loginForm.city) {
            that.loginForm.cityId = item.id
          }
        })
      })

      this.showCity = false
    },
    /*
      省市区管理
     */
    async handleGetCity(goal, func) {
      this.$api('PROVINCE_CITY_SEARCH_H5', {
        personId: this.regionCode
      }, true).then((res) => {
        // eslint-disable-next-line eqeqeq
        if (goal == 'city') {
          this.areaListCity = res.result.map(item => {
            const { id, name } = item
            return {
              id,
              name
            }
          })
          this.columnsCity = []
          this.areaListCity.forEach(item => {
            this.columnsCity.push(item.name)
          })
          return
        }
        this.areaList = res.result.map(item => {
          const { id, name } = item
          return {
            id,
            name
          }
        })
        this.columns = []
        this.areaList.forEach(item => {
          this.columns.push(item.name)
        })
        if (func) {
          func()
        }
      })
    },
    /*
      获取验证码（注册）
     */
    handleGetLoginCOdeClick() {
      this.$api('BASE_SEND_VERIFY_H5', {
        phonenum: this.loginForm['phonenum'],
        vertifyCodeType: 'REGISTER'
      }).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res.msg)
        }
      })
    },
    /*
      注册
     */
    handleSubmitClick() {
      if (this.loginForm.test !== true) {
        Toast('您需要同意协议内容')
        return
      }
      if (!this.loginForm.provinceId || this.loginForm.provinceId.length === 0) {
        Toast('请重新选择省份')
        return
      }
      if (!this.loginForm.cityId || this.loginForm.cityId.length === 0) {
        Toast('请重新选择城市')
        return
      }
      if (!this.loginForm.hospitalAddress || (this.loginForm.hospitalAddress.length !== 0 && this.loginForm.hospitalAddress.length < 2 || this.loginForm.hospitalAddress.length > 32)) {
        Toast('所属地址的长度不能小于2位大于32位')
        return
      }
      if (!this.loginForm.hospitalDepartment || (this.loginForm.hospitalDepartment.length !== 0 && this.loginForm.hospitalDepartment.length < 2 || this.loginForm.hospitalDepartment.length > 32)) {
        Toast('所属科室的长度不能小于2位大于32位')
        return
      }
      if (!this.loginForm.hospitalPosition || (this.loginForm.hospitalPosition.length !== 0 && this.loginForm.hospitalPosition.length < 2 || this.loginForm.hospitalPosition.length > 32)) {
        Toast('职位的长度不能小于2位大于32位')
        return
      }
      if (!this.loginForm.name || (this.loginForm.name.length !== 0 && this.loginForm.name.length < 2 || this.loginForm.name.length > 32)) {
        Toast('姓名的长度不能小于2位大于32位')
        return
      }

      if (!this.loginForm.phonenum || (this.loginForm.phonenum.length !== 11)) {
        Toast('请输入11位数手机号')
        return
      }

      if (!this.loginForm.vertifyCode || (this.loginForm.vertifyCode.length < 4)) {
        Toast('验证码不能小于4位')
        return
      }
      // delete this.loginForm.city
      // delete this.loginForm.province
      this.$api('USER_REGISTER_H5', this.loginForm, true).then((res) => {
        if (res.code !== 200) {
          this.$toast.fail(res.msg)
          return
        }
        this.$router.push({ path: '/' })
        this.$toast.success('注册成功')
      })
    },
    handleGetCodeClick() {
      this.handleGetLoginCOdeClick()
      const phone = this.loginForm['phonenum']
      if (phone && PHONE_REG.test(phone)) {
        // 模拟请求
        setTimeout(() => {
          this.handleCountDownAction()
        }, 1000)
        return
      }
      this.$toast.fail('请输入正确手机号码')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/base/form.scss';

.register {
  height: 100%;

  .equipment-popup {
    height: 245px;
  }

  .back-ground {
    width: 100%;
    height: 100%;
    z-index: -999;
    position: absolute;
  }

  ::v-deep .van-cell {
    background-color: rgba(0, 0, 0, 0);
  }

  .register-logo {
    display: flex;
    justify-content: center;

    img {
      width: 171px;
      height: 22px;
      margin-top: 45px;
    }
  }

  .login-form {
    margin-bottom: 18.5px;

    .compile-icon {
      width: 17px;
      height: 17px;
    }

    /*深度挖掘组件的字体大小*/
    ::v-deep .dr__maintenance {
      background-color: rgba(0, 0, 0, 0);
    }

    ::v-deep .van-button--plain {
      background-color: transparent;
    }

    ::v-deep .dr__maintenance .base-info {
      padding: 0;
      margin-bottom: 18.5px;
      margin-left: 5px;
    }

    ::v-deep .label-split {
      display: flex;
      justify-content: space-between;
      width: 64px;
    }

    ::v-deep .dr__maintenance .base-info .info-item {
      .info_label {
        margin-left: 3px;

        .label span {
          font-size: 15px;
        }
      }

      p {
        font-size: 15px;
        margin-left: 5px;
        color: #000000;
      }
    }

    .button-enroll-button {
      width: 326px;
      margin: 0 auto;
      outline: none;
      border: none;
    }

    button {
      border: none;
    }

    .button-enroll {
      padding-bottom: 40px;
      margin-top: 16px;
    }
  }
}
</style>
